if (!customElements.get('teema-purchase-price')) {
  customElements.define('teema-purchase-price', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.input = this.product?.querySelector('.product-form__quantity .quantity__input');
      this.button = this.closest('product-form')?.querySelector('.product-form__submit');
      if (!this.button) return;
      this.update = this.update.bind(this);
      this.input?.addEventListener('input', this.update);
      this.input?.addEventListener('change', this.update);
      // Dawn can reset the quantity when a variant or cart quantity changes.
      this.unsubscribers = [
        subscribe(PUB_SUB_EVENTS.quantityUpdate, () => queueMicrotask(this.update)),
        subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (data.sectionId === this.product.dataset.section) this.update();
        }),
      ];
      // Native Dawn may restore the button label after a variant change.
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.button, {childList: true, subtree: true, attributes: true});
      this.update();
    }

    update() {
      if (!this.isConnected || this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
      const prices = this.querySelector('[data-unit-price]');
      const label = this.button.querySelector('span');
      if (!prices || !label) return;
      const quantity = Number(this.input?.value ?? 1);
      if (!Number.isSafeInteger(quantity) || quantity <= 0 || (this.input && !this.input.checkValidity())) {
        if (label.textContent !== prices.dataset.label) label.textContent = prices.dataset.label;
        return;
      }
      let unitPrice = Number(prices.dataset.unitPrice);
      const pricingQuantity = quantity + (Number(this.input?.dataset.cartQuantity) || 0);
      const breaks = JSON.parse(prices.dataset.priceBreaks || '[]') || [];
      for (const tier of [...breaks].sort((a, b) => a.minimum_quantity - b.minimum_quantity)) {
        if (pricingQuantity >= tier.minimum_quantity) unitPrice = tier.price;
      }
      const amount = unitPrice * quantity;
      const currency = prices.dataset.currency;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency, currencyDisplay: 'narrowSymbol',
      });
      const format = value => formatter.format(value / 100) + (prices.dataset.currencyCode === 'true' ? ` ${currency}` : '');
      const text = `${prices.dataset.label} - ${format(amount)}`;
      if (label.textContent !== text) label.textContent = text;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.input?.removeEventListener('input', this.update);
      this.input?.removeEventListener('change', this.update);
      this.unsubscribers?.forEach(unsubscribe => unsubscribe());
    }
  });
}
